import { useContext, useEffect, useRef } from 'react'
import storeKeys from '../_Mappings/storeKeys'
import LoginContext from '../_Modules/Account/Login/LoginContext'
import { useCookies } from 'react-cookie'
import { COOKIE_LANGUAGE, COOKIE_LOCATION } from '../_Mappings/cookies'
import { EmarsysWebExtend } from '../_Modules/ThirdPartyScripts/EmarsysWebExtend'
import { useCart } from '@bloomreach/connector-components-react'
import { BrPageContext } from '@bloomreach/react-sdk'
import { useRouter } from 'next/router'

const useEmarsysEvents = (tag) => {
    //page 
    const page = useContext(BrPageContext)
    // Location
    const [cookies] = useCookies([COOKIE_LOCATION, COOKIE_LANGUAGE])
    const { storeKey } = storeKeys[cookies[COOKIE_LOCATION]] || {}

    // Cart and user
    const { cartId, user } = useContext(LoginContext)
    const [cart] = useCart({ cartId, storeKey }) 

    //Emarsys 
    const { pushCartActivity, trackPageVisit } = useContext(EmarsysWebExtend)
    const hasTrackedRef = useRef('')
    const router = useRouter();
    const path = router.asPath.slice(1);
    const url = `https://www.baldinini-shop.com/${path}`.split("?")[0]
    
    useEffect(() => {
        if (user && (hasTrackedRef.current !== page.getTitle() || (hasTrackedRef.current === page.getTitle() && page.getTitle() === "Product Detail" && path?.includes("products")))  ) {
            trackPageVisit(url, page.getTitle(), tag, cookies[COOKIE_LOCATION], cookies[COOKIE_LANGUAGE], user.currentCustomer?.email || undefined)
            pushCartActivity(cart?.entries || [], undefined)
            hasTrackedRef.current = page.getTitle()
        }
    }, [user, path, page.getTitle()])

}

export default useEmarsysEvents